import {
  generateGetInfiniteResourceKey,
  generateGetResourceKey,
  generateHttpGet,
} from "../../utils/fetcherUtils";

import { Params, Result } from "./typing";

export const httpGet$GetSecondaryOffers = generateHttpGet<Params, Result>(
  Result.parse
);

export const getResourceKey$GetSecondaryOffers = generateGetResourceKey<Params>(
  ["5d304dd0-ee74-4d2e-99af-6b06a6bad339"]
);

export const getInfiniteResourceKey$GetSecondaryOffers =
  generateGetInfiniteResourceKey<Params>([
    "389fa031-ef85-4967-b65b-02a2cbc503c1",
  ]);
